module.exports = __webpack_public_path__ + "img/tag_picture.6e38b0ba.png";